export default __webpack_public_path__ + "static/media/region.fe330b4e.svg";